export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f50ac44db4f4f260fadc42f29baf4b0bc8495f966&name=fetchTypeahead!'